import React from 'react';
import { Box, TextV2, Flex, ButtonV2, IconV2 } from '@withjoy/joykit';
import { useTranslation } from '@shared/core';
import { CheckOutline } from '@withjoy/joykit/icons';
import { ReactComponent as Warning } from '@assets/icons/Error-32.svg';
import { PayoutStatus } from './PayoutDialog';
import { useCreditCardSetupTelemetry } from '../CreditCardSetUp.telemetry';

export const StatusPayoutDialog: React.FC<{ onClose: () => void; status: PayoutStatus }> = ({ onClose, status }) => {
  const telemetry = useCreditCardSetupTelemetry();
  const { t2 } = useTranslation('sharedRegistry');
  const { successTitle, successDescription, close, errorTitle, errorDescription } = t2('payoutDialog');
  return (
    <>
      <Flex
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        marginBottom={5}
      >
        <IconV2
          size="xxl"
          color={status === 'success' ? 'mono14' : 'negative6'}
        >
          {status === 'success' ? <CheckOutline /> : <Warning />}
        </IconV2>
        <TextV2
          textAlign="center"
          typographyVariant="display1"
          color="mono14"
        >
          {status === 'success' ? successTitle : errorTitle}
        </TextV2>
      </Flex>
      <Flex
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
      >
        <Flex
          justifyContent="center"
          marginBottom={8}
        >
          <TextV2
            textAlign="center"
            typographyVariant="body3"
            color="mono12"
          >
            {status === 'success' ? successDescription : errorDescription}
          </TextV2>
        </Flex>
        <Box>
          <ButtonV2
            onClick={() => {
              telemetry.closePayoutDialogStatusButtonClicked(status);
              onClose();
            }}
            size="lg"
            intent="neutral"
            shape="rounded"
            variant="outline"
          >
            {close}
          </ButtonV2>
        </Box>
      </Flex>
    </>
  );
};
